<template>
    <div class="animated fadeIn">
        <b-card >
            <template v-slot:header>
                <h5>Laporan Penjualan</h5>
            </template>
            <div class="search-wrapper align-items-center justify-content-between">
                <b-form-group
                    label="Periode"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex align-items-center search-input-wrapper">
                        <b-form-select class="ml-2 mr-2" v-model="input.bulan" id="inputBulan" name="inputBulan" :options="optionBulan">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Bulan</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-select v-model="input.tahun" id="inputTahun" name="inputTahun" :options="optionTahun">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Tahun</b-form-select-option>
                            </template>
                        </b-form-select>
                    </div>
                </b-form-group>
                <b-button variant="pgiBtn" class="mr-2 download-btn" :disabled="isLoading" @click="confirmLaporanWeb()">
                    Lihat di Web
                </b-button>
                <b-button variant="pgiBtn" class="download-btn" :disabled="isLoading" @click="confirmLaporanDownload()">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
        </b-card>

        <div v-if="showWebPeriode">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Laporan Penjualan</h4>
                        <h6>
                            Periode : <span v-if="periodeBulan != '-'">{{ periodeBulan }}</span> <span v-else>Tahun</span> <span>{{ periodeTahun }}</span>
                        </h6>
                    </div>
                </div>
                <div class="mb-4">
                    <b-form-group class="form-inline" label-for="tipePinjaman" label="Tipe Pinjaman">
                        <b-form-select class="ml-2" v-model="input.tipePinjamanLaporan" name="tipePinjamanLaporan" :options="tipePinjamanOption" value-field="id" text-field="name">
                        </b-form-select>
                    </b-form-group>
                </div>
                <b-row>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-shopping-bag"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Unit</p>
                                    <strong class="mb-0">{{$helper.addThousandSeparator(showDataPenjualanAll.unit)}}</strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-calculator"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Modal</p>
                                    <strong class="mb-0">Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.modal)}}</strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-money"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Harga Jual</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.hargaJual)}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-dollar"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Laba</p>
                                    <strong class="mb-0" v-if="showDataPenjualanAll.margin == null">{{$helper.addThousandSeparator(showDataPenjualanAll.margin)}} </strong>
                                    <strong class="mb-0" v-else-if="showDataPenjualanAll.margin < 0">- Rp{{$helper.addThousandSeparator(showDataPenjualanAll.margin).replace("-", "")}}</strong>
                                    <strong class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.margin)}} </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-card >
                    <template v-slot:header>
                        <h5>Laporan Penjualan</h5>
                    </template>
                    <div class="search-wrapper d-flex align-items-center justify-content-between">
                        <b-form-group
                            label="Filter"
                            label-for="filterInput"
                            class="form-inline form-group-wrapper mb-3"
                        >   
                            <div class="d-flex search-input-wrapper">
                                <multiselect
                                    class="ml-2 mr-2"
                                    name="filterCabang"
                                    v-model="input.filterCabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih filter cabang --"
                                />
                                <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                    <i class="fa fa-search"></i>
                                </b-button>
                                <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                            </div>
                        </b-form-group>
                    </div>
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="showDataPenjualan" 
                        :fields="fields" 
                        :currentPage="currentPage" 
                        :perPage="perPage"
                        responsive class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data penjualan.
                        </template>
                        <template v-slot:cell(unit)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unit) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(modal)="row">
                            <div class="text-right no-wrap" v-if="row.item.modal == null">{{$helper.addThousandSeparator(row.item.modal)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.modal < 0">- Rp{{$helper.addThousandSeparator(row.item.modal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.modal)}} </div>
                        </template>
                        <template v-slot:cell(hargaJual)="row">
                            <div class="text-right no-wrap">
                                <p class="mb-0" v-if="row.item.hargaJual == null">{{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                                <p class="mb-0" v-else-if="row.item.hargaJual < 0">- Rp{{$helper.addThousandSeparator(row.item.hargaJual).replace("-", "")}}</p>
                                <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                            </div>
                        </template>
                        <template v-slot:cell(margin)="row">
                            <div class="text-right no-wrap">
                                <p class="mb-0" v-if="row.item.margin == null">{{$helper.addThousandSeparator(row.item.margin)}} </p>
                                <p class="mb-0" v-else-if="row.item.margin < 0">- Rp{{$helper.addThousandSeparator(row.item.margin).replace("-", "")}}</p>
                                <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.margin)}} </p>
                            </div>
                        </template>
                    </b-table>

                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewText }}</span>
                        </b-input-group>
                        <b-pagination class="mb-0"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                        ></b-pagination>
                    </div>

                </b-card>
            </div>
        </div>

        <div v-if="showWebTahunan">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Laporan Penjualan</h4>
                        <h6>
                            Periode : <span v-if="periodeBulan != '-'">{{ periodeBulan }}</span> <span v-else>Tahun</span> <span>{{ periodeTahun }}</span>
                        </h6>
                    </div>
                </div>
                <div class="mb-4">
                    <b-form-group class="form-inline" label-for="tipePinjaman" label="Tipe Pinjaman">
                        <b-form-select class="ml-2" v-model="input.tipePinjamanLaporan" name="tipePinjamanLaporan" :options="tipePinjamanOption" value-field="id" text-field="name">
                        </b-form-select>
                    </b-form-group>
                </div>
                <b-row>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-shopping-bag"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Unit</p>
                                    <strong class="mb-0">{{$helper.addThousandSeparator(showDataPenjualanAll.unit)}}</strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-calculator"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Modal</p>
                                    <strong class="mb-0">Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.modal)}}</strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-money"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total Harga Jual</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.hargaJual)}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col xl="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-dollar"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Laba</p>
                                    <strong class="mb-0" v-if="showDataPenjualanAll.margin == null">{{$helper.addThousandSeparator(showDataPenjualanAll.margin)}} </strong>
                                    <strong class="mb-0" v-else-if="showDataPenjualanAll.margin < 0">- Rp{{$helper.addThousandSeparator(showDataPenjualanAll.margin).replace("-", "")}}</strong>
                                    <strong class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(showDataPenjualanAll.margin)}} </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-card >
                    <template v-slot:header>
                        <h5>Laporan Penjualan</h5>
                    </template>
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="showDataPenjualan" 
                        :fields="fieldTahunan" 
                        responsive class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data penjualan.
                        </template>
                        <!-- <template v-slot:thead-top>
                            <b-tr>
                                <b-th># </b-th>
                                <b-th colspan="3">Elektronik</b-th>
                                <b-th colspan="3">BPKB & Kendaraan</b-th>
                            </b-tr>
                        </template> -->
                        <template v-slot:cell(unit)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.unit) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(modal)="row">
                            <div class="text-right no-wrap" v-if="row.item.modal == null">{{$helper.addThousandSeparator(row.item.modal)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.modal < 0">- Rp{{$helper.addThousandSeparator(row.item.modal).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.modal)}} </div>
                        </template>
                        <template v-slot:cell(hargaJual)="row">
                            <div class="text-right no-wrap">
                                <p class="mb-0" v-if="row.item.hargaJual == null">{{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                                <p class="mb-0" v-else-if="row.item.hargaJual < 0">- Rp{{$helper.addThousandSeparator(row.item.hargaJual).replace("-", "")}}</p>
                                <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.hargaJual)}} </p>
                            </div>
                        </template>
                        <template v-slot:cell(margin)="row">
                            <div class="text-right no-wrap">
                                <p class="mb-0" v-if="row.item.margin == null">{{$helper.addThousandSeparator(row.item.margin)}} </p>
                                <p class="mb-0" v-else-if="row.item.margin < 0">- Rp{{$helper.addThousandSeparator(row.item.margin).replace("-", "")}}</p>
                                <p class="mb-0" v-else>Rp. {{$helper.addThousandSeparator(row.item.margin)}} </p>
                            </div>
                        </template>
                    </b-table>

                </b-card>
            </div>
        </div>
        <b-modal id="modal-web-password" @shown="focusLaporanWebPassword" title="Confirm Web Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webPasswordForm" @submit.prevent="openLaporanWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordWeb"
                        v-model="input.passwordWeb"
                        name="passwordWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-password" @shown="focusLaporanDownloadPassword" title="Confirm Download Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadExcelPasswordForm" @submit.prevent="openLaporanDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordDownload"
                        v-model="input.passwordDownload"
                        name="passwordDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadExcelPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'laporan-penjualan',
    data(){
        return{
            isSubmitting: false,
            input:{
                bulan: 0,
                tahun: 2020,
                passwordDownload: "",
                passwordWeb: "",
                //
                show: 10,
                filterCabang: null,
                tipePinjamanLaporan: 1,
            },
            tipePinjamanOption: [
                {id: 1, name: 'Elektronik'},
                {id: 2, name: 'BPKB'},
                {id: 4, name: 'Emas'}
            ],
            optionTahun: [],
            optionBulan: [
                { value: "0", text: "-" },
                { value: "1", text: "Januari" },
                { value: "2", text: "Februari" },
                { value: "3", text: "Maret" },
                { value: "4", text: "April" },
                { value: "5", text: "Mei" },
                { value: "6", text: "Juni" },
                { value: "7", text: "Juli" },
                { value: "8", text: "Agustus" },
                { value: "9", text: "September" },
                { value: "10", text: "Oktober" },
                { value: "11", text: "November" },
                { value: "12", text: "Desember" }
            ],
            
            isLoading: false,
            filePathDownload: "",
            query: "",

            showWebPeriode: false,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',

            //
            showWebTahunan: false,
            periodeBulan: '',
            periodeTahun: '',
            isBusy: true,
            fields: [
                { key: "cabangName", label: "Cabang" },
                { key: "unit", label: "Unit", sortable: true },
                { key: "modal", label: "Modal", sortable: true },
                { key: "hargaJual", label: "Nilai Jual", sortable: true },
                { key: "margin", label: "Laba", sortable: true },
            ],
            fieldTahunan: [
                { key: "cabangName", label: "Bulan" },
                { key: "unit", label: "Unit", sortable: true },
                { key: "modal", label: "Modal", sortable: true},
                { key: "hargaJual", label: "Nilai Jual", sortable: true },
                { key: "margin", label: "Laba", sortable: true },
            ],
            dataPenjualan: [],

            dataPenjualanAll : {},
            showDataPenjualanAll : [],
            showDataPenjualan: [],
        }
    }, 
    watch: {
        "input.tipePinjamanLaporan": function(newValue) {
            if(newValue == 1){
                this.showDataPenjualanAll = this.dataPenjualanAll.elek
                this.showDataPenjualan = this.dataPenjualanAll.elek.entries
            }else if(newValue == 2){
                this.showDataPenjualanAll = this.dataPenjualanAll.bpkb
                this.showDataPenjualan = this.dataPenjualanAll.bpkb.entries
            }else{
                this.showDataPenjualanAll = this.dataPenjualanAll.kend
                this.showDataPenjualan = this.dataPenjualanAll.kend.entries
            }
            this.updateTotalItem()
            this.input.filterCabang = null
            this.perPage = 10
            this.currentPage = 1
        },
    },
    methods: {
		init(){
			var thisYear = new Date().getFullYear()
			for(var i = 2016; i <= thisYear; i++) {
				this.optionTahun.push(i)
			}
		},
        focusLaporanWebPassword(){
            this.$refs.passwordWeb.focus()
        },
        focusLaporanDownloadPassword(){
            this.$refs.passwordDownload.focus()
        },

        confirmLaporanDownload(){
            if(this.input.bulan == null || this.input.tahun == null){
                this.$helper.toastErr(this, "Mohon isi periode laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openLaporanDownload()
                    this.input.passwordDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-download-password')
                }
            }
        },

        openLaporanDownload(){
            this.showWebTahunan = false
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-download-password')
            setTimeout(() => { this.axiosLaporanDownload() }, 500)
        },

        axiosLaporanDownload(){
            this.query = `bulan=${this.input.bulan}&tahun=${this.input.tahun}&password=${this.input.passwordDownload}`
            this.$axios.get(`laporan-eksekutif/penjualan/dl/?${this.query}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        confirmLaporanWeb(){
            if(this.input.bulan == null || this.input.tahun == null){
                this.$helper.toastErr(this, "Mohon isi periode laporan!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openLaporanWeb()
                    this.input.passwordWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-web-password')
                }
            }
        },

        openLaporanWeb(){
            let idx = this.optionBulan.findIndex(item => item.value == this.input.bulan)
            this.periodeBulan = this.optionBulan[idx].text
            this.periodeTahun = this.input.tahun
            
            if(this.periodeBulan != '-'){
                this.showWebPeriode = true
                this.showWebTahunan = false
            }else{
                this.showWebPeriode = false
                this.showWebTahunan = true
            }
            this.isLoading = true
            this.$bvModal.hide('modal-periode-webPassword')
            this.$bvModal.hide('modal-web-password')
            setTimeout(() => { this.axiosLaporanWeb() }, 500)
        },

        axiosLaporanWeb(){
            let getCabang = this.checkJenisLaporan()

            let getDataPenjualan = this.$axios.get(`laporan-eksekutif/penjualan/?bulan=${this.input.bulan}&tahun=${this.input.tahun}&password=${this.input.passwordWeb}`).then(response => {
                this.dataPenjualanAll = response.data
                this.showDataPenjualanAll = response.data.elek
                this.showDataPenjualan = response.data.elek.entries
                this.input.tipePinjamanLaporan = 1
                this.updateTotalItem()
                this.perPage = 10
                this.currentPage = 1
               
            })

            Promise.all([getCabang, getDataPenjualan]).then(() => {
                this.input.filterCabang = null
                this.isLoading = false
                this.isBusy = false
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordWeb = ""
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordWeb = ""
                this.showWebTahunan = false
                this.showWebPeriode = false
                this.isLoading = false
            })
        },

        checkJenisLaporan(){
            if(this.periodeBulan != '-'){
                if(this.cabangOption.length == 0){
                    this.$axios.get("cabang/all-selection").then(response => {
                        response.data.forEach((element) => {
                            if(element.id != this.srcCabangId)
                                this.cabangOption.push(element)
                        })
                    })
                }
            }else{
                this.cabangOption = []
            }
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataPenjualan(){
            this.showDataPenjualan = this.showDataPenjualanAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.input.filterCabang = null
            this.toggleBusy()
            this.getDataPenjualan()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.showDataPenjualanAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.showDataPenjualan = filteredArray
                this.onFiltered(this.showDataPenjualan)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.showDataPenjualan.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

	},
	created(){
        this.init()
    }
}
</script>